module.exports = __webpack_public_path__ + "img/197.8edf6b16.jpg";